module.exports = __webpack_public_path__ + "img/new6.b97874f8.jpg";